import {
  AfterContentInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
} from "@angular/core";
import { AppUtils } from "../../app-utils";
import { Title } from "@angular/platform-browser";
import { RichSearchList } from "../../../search/search-list/rich-search-list";
import { ResultDetails } from "../../../search/fulltext/result-details";
import { SearchService } from "../../../search/search.service";
import { Filter } from "../../../search/search-list/filters/filter-block/filter-item/filter";
import { TranslateService } from "../../translate.service";
import { SearchRequest } from "../../../search/search-request.model";
import { HtmlUtilsService } from "../../../html-utils/html-utils.service";
import { ActivatedRoute } from "@angular/router";
import { QueryParams } from "../query-params.model";

@Component({
  selector: "app-result-list",
  templateUrl: "./result-list.component.html",
  styleUrls: ["./result-list.component.scss"],
})
export class ResultListComponent implements AfterContentInit, OnInit {
  loaded = true;

  @Input() facets: Filter[];

  @Input() searchResult: RichSearchList;

  @Input() inProgress = true;

  @Input() omitTitle = false;

  textOnly: boolean;

  @Input("textOnly") set _textOnly(value: boolean) {
    this.textOnly = value;
  }

  query: string;

  loadMoreFromPageEmitter = new EventEmitter<QueryParams>();

  mobileHideableResultCount = 0;

  showMoreLoadingIndicator = false;

  mobileVersion = false;

  constructor(
    private activeRoute: ActivatedRoute,
    private searchService: SearchService,
    private htmlUtils: HtmlUtilsService,
    public translator: TranslateService,
    private titleService: Title
  ) {}

  getQueryParams(): { page: number; filters: string } {
    const filters = AppUtils.phraseToFilter(
      this.searchResult.phraseSuggest
    ).toURL();
    return {
      page: 1,
      filters: filters,
    };
  }

  getResultDetails(searchResult: any, id: string) {
    if (searchResult.resultDetails) {
      let resultDetails: ResultDetails[] = searchResult.resultDetails;

      return resultDetails.find((rd) => rd.resultId === +id);
    }
  }

  ngOnInit(): void {
    this.htmlUtils.mobileBehaviorSubject.subscribe((mobileVersion) => {
      this.mobileVersion = mobileVersion;
    });
    if (!this.omitTitle) {
      this.titleService.setTitle(
        "Omnis - " + this.translator.translate("Results.label")
      );
    }
  }

  ngAfterContentInit(): void {
    this.activeRoute.queryParamMap.subscribe((params) => {
      this.query = params.get("query") || params.get("phrase");
      this.loaded = true;
    });
    // this.loadMoreFromPageEmitter.pipe(
    //   debounceTime(500),
    //   distinctUntilChanged()
    // ).subscribe(page => {
    //   this.appendResultToCurrentView(page);
    // });
  }

  private appendResultToCurrentView(search: QueryParams) {
    this.showMoreLoadingIndicator = true;
    const previousResults = Array.from(this.searchResult.search);
    const searchRequest = new SearchRequest({
      phrase: search.phrase,
      page: +search.page,
      pageSize: +search.pageSize,
      sort: search.sort,
      filter: search.filters,
      textOnly: search.searchInText,
    });
    this.searchService.findAll(searchRequest).subscribe(
      (value) => {
        this.mobileHideableResultCount = previousResults.length;
        this.searchResult = this.searchService.searchList;
        this.searchResult.search = previousResults.concat(
          this.searchResult.search
        );
        this.showMoreLoadingIndicator = false;
      },
      (error) => {
        this.showMoreLoadingIndicator = false;
      }
    );
  }
}
